enum ParticipationLocationType {
  VIRTUAL = "VIRTUAL",
  TABLE = "TABLE",
  BOOTH = "BOOTH",
  BOOTH_AND_TABLE = "BOOTH_AND_TABLE",
  ACTIVITY = "ACTIVITY"
}

export default ParticipationLocationType;
